import React, { useEffect, useState } from "react";
import LockerDetailsComponent from "../components/LockerDetailsComponent";
import DateTimeSelector from "../components/DateTimeSelector";
import { useHistory } from "react-router-dom";
import { advanceBookingLockerBankDetails } from "../api/api";
import { getSecureItemFromSpecificStorage, storeSecureItemInSpecifiedStorage } from "../lib/BrowserStorageAccessMiddleware";
import { ADVANCE_BOOKING, LOCAL_STORAGE, LS_BOOKING_TYPE, LS_TENANT_ASSIGNMENT_LOCKER_BANK_SETTINGS } from "../assets/constants/BrowserStorageKeys";
import { useTranslation } from "react-i18next";
import { getPathForNextPage, getPriceFor24Hr, getPriceForSelectedTiming, getRoundedDurationInHours, getSlotIdFor24Hourse } from "../lib/Utils";
import { LOCKER_DETAILS, LOCKER_SIZE_SELECTION, BOOKING_SUMMARY } from "../assets/constants/PageList";
import ShowToast from "../components/ToastComponent";
import { TOAST_ERROR, POD_BANK_TYPE } from "../assets/constants/Constants";

export default function LockerDetailsPage() {
  const history = useHistory();
  const { t } = useTranslation();
  const { lockerDetails } = history.location?.state || {};
  const [showDateTimeSelector, setShowDateTimeSelector] = useState(false);


  const handleBookStore = () => {
    setShowDateTimeSelector(true);

    // Scroll to DateTimeSelector smoothly
    setTimeout(() => {
      document
        .querySelector(".locker-details-page__datetime-section")
        ?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
    }, 100);
  };

  const handleDateTimeContinue = async(dateTimeData) => {
    // Combine locker details + datetime
    const bookingData = {
        locker: lockerDetails,
        ...dateTimeData,
    };
  const requestData = {
    lockerBankId: lockerDetails?.id,
    reserve_start: bookingData?.reserve_start,
    reserve_end: bookingData?.reserve_end
  };

    let response;
    try {
      response = await advanceBookingLockerBankDetails(requestData);
    } catch (error) {
      console.error("advanceBookingLockerBankDetails error:", error);
      const message = t('error_msg_something_went_wrong_try_again');
      ShowToast(t(message), TOAST_ERROR);
      return false;
    }

    if (!response?.data?.data) {
      ShowToast(t("error_msg_something_went_wrong_try_again"), TOAST_ERROR);
      return false;
    }

    const advancelockerResponse = response?.data?.data;

    const tempdata = {
        lockerBankId: advancelockerResponse?.id,
        bookingTimingObject: {
          ...dateTimeData
        },
        assignmentSlug: advancelockerResponse?.locker_assignments[0]?.slug,
        locker_bank_slug:advancelockerResponse?.slug,
        userId: null,
        availableLockerSizes: advancelockerResponse?.door_sizes || [],
        isManualLockerSelectionEnabled: advancelockerResponse?.isManualLockerSelectionEnabled,
        IsAdvanceBooking: true,
        lockerCurrency: advancelockerResponse?.locker_assignments[0]?.currency,
    };
    storeSecureItemInSpecifiedStorage(LOCAL_STORAGE, LS_BOOKING_TYPE, ADVANCE_BOOKING )

    const isPodLockerType = String(lockerDetails?.LockerBankType).toLowerCase() === POD_BANK_TYPE;

    if (isPodLockerType) {
      const hasFreeLocker = tempdata.availableLockerSizes?.some(
        (lockerSize) => Number(lockerSize?.available_doors_count) > 0
      );

      if (! hasFreeLocker) {
        ShowToast(t("error_msg_no_free_locker_available"), TOAST_ERROR);
        return false;
      }

      const tenantAndAssignmentSettings = getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_TENANT_ASSIGNMENT_LOCKER_BANK_SETTINGS);
      const isPricingEnabled = tenantAndAssignmentSettings?.is_pricing;
      const podLockerSize = tempdata.availableLockerSizes?.[0];
      const price = isPricingEnabled
        ? getPriceForSelectedTiming(
            getRoundedDurationInHours(dateTimeData?.reserve_start, dateTimeData?.reserve_end),
            getPriceFor24Hr(podLockerSize?.size_pricing)
          )
        : 0;

      const selectedLockers = podLockerSize
        ? [
            {
              door_size: podLockerSize?.code,
              price,
              slot_id: getSlotIdFor24Hourse(podLockerSize?.size_pricing),
              name: `${podLockerSize?.name} Locker`,
            },
          ]
        : [];

      history.push({
        pathname: getPathForNextPage(LOCKER_DETAILS, BOOKING_SUMMARY),
        state: {
          ...tempdata,
          lockerName: lockerDetails?.name,
          selectedLockers,
        },
      });

      return true;
    }

    history.push({
        pathname: getPathForNextPage(LOCKER_DETAILS, LOCKER_SIZE_SELECTION),
        state: { ...tempdata }
    });

    return true;
  };

  if (!lockerDetails) {
    return (
      <div className="locker-details-page">
        <div className="locker-details-page__error">
          <h2>{t("no_locker_details_found_title")}</h2>
          <p>{t("go_back_select_locker_text")}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="locker-details-page">
        {!showDateTimeSelector ? (
          <div className="locker-details-container">
            <LockerDetailsComponent
              locker={lockerDetails}
              onBook={handleBookStore}
            />
          </div>
        ) : (
          <div className="locker-datetime-picker-container">
            <DateTimeSelector onContinue={handleDateTimeContinue} lockerType={lockerDetails?.LockerBankType} />
          </div>
        )}
      </div>
  );
}
